import { useEffect, useState } from 'react';
import './UndoToast.css';

export interface UndoToastProps {
  message: string;
  /** Absolute timestamp (ms epoch) at which the action commits. */
  expiresAt: number;
  onUndo: () => void;
}

export function UndoToast({ message, expiresAt, onUndo }: UndoToastProps): JSX.Element {
  const [remaining, setRemaining] = useState(() => Math.max(0, expiresAt - Date.now()));

  useEffect(() => {
    let frame: number;
    const tick = (): void => {
      setRemaining(Math.max(0, expiresAt - Date.now()));
      frame = window.requestAnimationFrame(tick);
    };
    frame = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(frame);
  }, [expiresAt]);

  const seconds = Math.ceil(remaining / 1000);

  return (
    <div className="bl-undo" role="alert" aria-live="polite">
      <span className="bl-undo__message">{message}</span>
      <span className="bl-undo__countdown" aria-hidden="true">
        {seconds}s
      </span>
      <button type="button" className="bl-undo__button" onClick={onUndo}>
        Undo
      </button>
    </div>
  );
}
